import { v4 as uuidv4 } from 'uuid';
import recommendedData from './data/recommended-publishers.json';

function getRecommendedPublishers() {
    this.recommendedPublishers = recommendedData.publishers;
    this.observed.recommendedPublishers = uuidv4();
}

export default getRecommendedPublishers;
